type MembershipRow = {
  organization: {
    slug: string | null;
  };
};

export const isOrgSlugInMemberships = (
  memberships: MembershipRow[] | undefined,
  orgSlug: string,
): boolean =>
  memberships?.some((membership) => membership.organization.slug === orgSlug) ?? false;
